import React from "react";
import ContentComponent from 'D:/projects/flash/packages/act-labs-blog/src/content/posts/aws-event-sourcing.md';
import OneColumnLayout from 'components/page-layout';

export default function SnippetsLayout(props) {
    return <OneColumnLayout {...props}><ContentComponent {...props}/></OneColumnLayout>
}

